import { PayloadAction } from "@reduxjs/toolkit";

import { DriversState } from '../../types';

export const setSelectedDriverFuelAssignment = (
  state: DriversState,
  action: PayloadAction<DriversState['selectedFuelAssignment']>
) => {
  state.selectedFuelAssignment = action.payload;
}